export default __webpack_public_path__ + "static/media/0x9c6bfedc14b5c23e3900889436edca7805170f01.d12085a3.webp";